// extracted by mini-css-extract-plugin
export var modalFooter = "_nd-0";